import styled from 'styled-components'
import ripple from '../../../../styles/animations/ripple'
import { darken } from 'polished'

export const FileStyles = {
  Content: styled.div`
    display: flex;
    flex-direction: flex;
    align-items: center;
    gap: 10px;
  `,
  Title: styled.div`
    text-align: center;
    width: 100%;
    margin: 5px 0px;
    font-size: 16px;
  `,
  Container: styled.div`
    display: flex;
    border-radius: 10px;
    flex-direction: column;
    background: ${({ theme }) => darken(-0.6, theme.colors.primary)};
    margin-bottom: 10px;
    gap: 10px;
    padding: 10px;
  `,
  Progress: styled.div`
    position: relative;
  `,
  ProgressContent: styled.div`
    width: 100%;
    border-radius: 100px;
    height: 4px;
    background-color: white;
  `,
  ProgressBar: styled.div<{ progress: number }>`
    position: absolute;
    width: ${({ progress }) => progress}%;
    transition: width 0.5s ease-in-out;
    border-radius: 100px;
    height: 4px;
    background-color: ${({ progress }) => (progress === 100 ? '#1A9E04' : '#646464')};
    bottom: 0px;
  `,
  FileImg: styled.img`
    width: 35px;
    height: 30px;
  `,
  Row: styled.div`
    display: flex;
    gap: 5px;
    flex-direction: row;
    align-items: center;
  `,
  Column: styled.div`
    width: 100%;
    display: flex;
    gap: 5px;
    flex-direction: column;
  `,
  Name: styled.div`
    color: ${({ theme }) => theme.colors.primary};
    font-size: 12px;
    font-style: normal;
    font-weight: 800;
    line-height: normal;
  `,
  Size: styled.div`
    color: ${({ theme }) => theme.colors.primary};
    font-size: 10px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  `,
  IconButton: styled.img`
    ${ripple}
    cursor: pointer;
    width: 20px;
    height: 20px;
  `,
  Icon: styled.img`
    width: 20px;
    height: 20px;
  `,
}
